import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { EventVenueType } from '@core/enums/event/event-venue-type.enum';
import { Cart } from '@core/models/cart/cart.model';
import { AuthService } from '@core/services/auth/auth.service';
import { CartStoreService } from '@core/services/cart/cart-store.service';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';

@Injectable()
export class CartGuard implements CanActivate {

  constructor(
    private cartStoreService: CartStoreService,
    private authService: AuthService,
    private router: Router
  ) { }

  canActivate(): Observable<boolean> {
    return this.cartStoreService.cart$
      .pipe(
        take(1),
        map((cart: Cart) => {
          const hasGiftCard: boolean = cart?.giftCardsToBuy?.length > 0;
          let hasCartItem = false;
          if (cart?.cartItems?.length) {
            const hasOnlineEvents: boolean = cart.cartItems.some(cartItem => cartItem.eventType === EventVenueType.ONLINE);
            hasCartItem = !hasOnlineEvents || this.authService.isAuthenticated;
          }
          const canActivate = hasGiftCard || hasCartItem;
          if (!canActivate) {
            this.router.navigate(['/cart']);
          }
          return canActivate;
        })
      );
  }

}
